import I18n from 'I18n';
import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Link } from 'foundations-components/transitional/components/Link';
import CreateActivityButton from '../CreateActivityButton';
import { useWAButtonState } from './hooks/useWAButtonState';
import { useButtonUpgradePath } from '../../hooks/useButtonUpgradePath';
import CommunicatorLogger from 'customer-data-tracking/loggers/CommunicatorLogger';
import { useCreateActivityPermissions } from 'crm-activity-creator-data/permission/CreateActivityPermissionsContext';
import { ALL_PROPERTIES_PANEL_GATE } from 'crm-activity-creator-data/auth/gateConstants';
import { useIsUngated } from 'crm-activity-creator-data/auth/hooks/useIsUngated';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function CreateWhatsAppButton({
  buttonSize,
  interactionName,
  isOverflow = false,
  objectTypeId,
  onClickActionComplete,
  objectId
}) {
  const {
    currentUserCanCommunicate
  } = useCreateActivityPermissions();
  const buttonState = useWAButtonState({
    objectTypeId,
    objectId,
    currentUserCanCommunicate
  });
  const isAllPropertiesPanelUngated = useIsUngated(ALL_PROPERTIES_PANEL_GATE);
  const openPropertiesPanel = useSendCrmMessageTopic(TOPIC_NAMES.OPEN_ALL_PROPERTIES_PANEL);
  const portalId = PortalIdParser.get();
  const whatsAppURL = `/contacts/${portalId}/contact/${objectId}/properties?search=WhatsApp`;
  const buildTooltipJsx = /*#__PURE__*/_jsxs(TFlex, {
    direction: "column",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "createActivityButtons.tooltip.whatsAppWithNoPhoneNumber.contact"
    }), /*#__PURE__*/_jsx(Link, {
      onClick: () => {
        CommunicatorLogger.log('communicatorInteraction', {
          action: 'Click add new WhatsApp number',
          activity: 'WHATS_APP (1007)',
          channel: 'WHATS_APP (1007)',
          source: 'communicator'
        });
        if (isAllPropertiesPanelUngated) {
          openPropertiesPanel({
            objectTypeId,
            objectId: String(objectId),
            initialSearchTerm: 'WhatsApp'
          });
        } else {
          window.location.href = whatsAppURL;
        }
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "createActivityButtons.tooltip.whatsAppAddNumber"
      })
    })]
  });
  const buttonUpgradePoint = useButtonUpgradePath(interactionName);
  const showUpgradeModal = buttonUpgradePoint && !buttonUpgradePoint.hasScope;
  const tooltip = buttonState.tooltipMessage ? typeof buttonState.tooltipMessage === 'string' ? I18n.text(buttonState.tooltipMessage) : buildTooltipJsx : undefined;
  return /*#__PURE__*/_jsx(CreateActivityButton, {
    buttonSize: buttonSize,
    disabled: showUpgradeModal ? false : buttonState.isDisabled,
    interactionName: interactionName,
    isLoading: buttonState.isLoading,
    isOverflow: isOverflow,
    seleniumSelector: "create-engagement-whats-app-button",
    dataTestId: "create-engagement-whats-app-button",
    tooltipMessage: tooltip,
    objectTypeId: objectTypeId,
    onClick: onClickActionComplete,
    objectId: objectId
  });
}
export default CreateWhatsAppButton;